/**
 * Événements du calendrier.
 */
export class CalendarEvent {
    event = undefined;
    calendar = undefined;
}

/**
 * Lorsqu'un utilisateur clique sur une case du calendrier.
 */
export class SlotDoubleClickEvent extends CalendarEvent {
    clickevent = undefined;
    slot = {
        bay: undefined,
        minute: undefined,
        date: undefined,
        other: undefined
    };
}

/**
 * Événements d'un block de calendrier.
 */
export class BlockEvent extends CalendarEvent {
    block = undefined;
}

/**
 * Lorsque l'utilisateur clique un block
 */
export class BlockDoubleClickEvent extends BlockEvent {
    clickevent = undefined;
}

/**
 * Lorsqu'un utilisateur change les informations d'un block
 */
export class BlockChangeEvent extends BlockEvent { 

}

/**
 * Lorsqu'un utilisateur clique sur une option du menu contextuel.
 */
export class BlockContextMenuClickEvent extends BlockEvent { 
    clickedOption = undefined;
    clickedOptionName = undefined;
}